<template>
    <div class="page-container">
        <div class="main">
            <!-- <div class="top">
                <h3 class="intro-txt">{{$route.name}}</h3>
            </div> -->

            <page :url="url" :form="form">

                <template slot="tableSearch" v-if="$store.state.roleId == '1070960390067716097'">
                    <el-form-item label="代理商编号">
                        <el-input v-model="form.agentId" placeholder="代理商编号"></el-input>
                    </el-form-item>
                </template>

                <template slot="buttonArea" v-if="$store.state.roleId == '1070960390067716097'">
                    <el-button type="primary" @click="addAgent" size="small">添加代理商</el-button>
                </template>

                <template slot="tableColumn">
                    <el-table-column
                            prop="agentId"
                            width="120px"
                            label="代理商编号"
                            align="center"
                            >
                    </el-table-column>

                    <el-table-column
                            prop="loginName"
                            width="150px"
                            label="代理商名称"
                            align="center"
                            >
                    </el-table-column>

                    <el-table-column
                            prop="balance"
                            width="130px"
                            :formatter="$formatter.FenToYuan"
                            label="余额"
                            align="center"
                            >
                    </el-table-column>

                    <el-table-column
                            prop="agentPayinRate"
                            width="120px"
                            label="代收费率"
                            align="center"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="agentPayoutRate"
                            width="120px"
                            label="代付费率"
                            align="center"
                            >
                    </el-table-column>

                    <el-table-column
                            prop="checkoutUrl"
                            width="300px"
                            label="收银台地址"
                            align="center"
                            >
                    </el-table-column>

                    <el-table-column
                            prop="tgGroupId"
                            width="100px"
                            label="tg群id"
                            align="center"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="tgGroupName"
                            width="200px"
                            label="tg群"
                            align="center"
                            >
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="80"
                            align="center"
                            v-if="$store.state.roleId == '1070960390067716097'"
                            >
                        <template slot-scope="scope">
                            <el-button 
                            type="primary"
                            plain
                            size="mini"
                            @click="edit(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </template>
            </page>

            <AgentEdit :show.sync="showDialog" :formData="formData" :action="action"></AgentEdit>

        </div>
    </div>

</template>

<script>
    import Page from '@/components/Page.vue'
    import AgentEdit from './AgentEdit'
    export default {
        name: "Systems",
        components: {
            'page': Page,
            AgentEdit:AgentEdit
        },
        data() {
            return {
                url: '/agent/selectList',
                action: '',
                form: {
                    agentId: ''
                },
                showDialog: false,
                formData: null
            }
        },
        methods: {
            addAgent() {
                this.action = "addAgent";
                this.formData = null;
                this.showDialog = true;
            },
            edit(row) {
                this.action = "editAgent";
                this.formData = row;
                this.showDialog = true;
            },
            deleteSystem(row){


            }
        }
    }
</script>

<style scoped>

</style>